import { Text } from "@chakra-ui/react";
import React from "react";

const PrimarySideHeader = (props) => {
  return <Text fontSize="lg" fontWeight="bold" color="primary.1" {...props} />;
};

export default PrimarySideHeader;
